import { USER_DATA_CONSTANT } from "../../_constants/Redux/userData.constant";

export const UserDataActions = {
  projectMenu,
  addProjectMenu,
  projectID,
  siteID,
  ADD_SITE_IDS,
  TOGGLE_COLUMN,
};

function projectMenu(data) {
  return { type: USER_DATA_CONSTANT.PROJECT_MENU, data };
}

function addProjectMenu(data) {
  return { type: USER_DATA_CONSTANT.ADD_PROJECT_MENU, data };
}

function projectID(data) {
  return { type: USER_DATA_CONSTANT.PROJECT_ID, data };
}

function siteID(data) {
  return { type: USER_DATA_CONSTANT.SITE_ID, data };
}

function ADD_SITE_IDS(data) {
  return { type: USER_DATA_CONSTANT.ADD_SITE_IDS, data };
}

function TOGGLE_COLUMN(data) {
  return { type: USER_DATA_CONSTANT.TOGGLE_COLUMN, data };
}
